export default "__VITE_ASSET__BAUjm37m__"